/**
 * Created by Ivan on 25/08/2017.
 */
import {isNull} from 'lodash';
let component = {
    props : ['restaurants'],
    methods : {
        getImage( restaurant )
        {
            if( 'gallery' in restaurant && !isNull(restaurant.gallery) && 'photos' in restaurant.gallery )
            {
                return restaurant.gallery.photos[0].large;
            }
            return '/assets/img/default_restaurant.jpg';
        },
        truncate : function(str){
            return str.substring(0, 140) + '...';
        }
    },
    computed : {
        currentLanguage : function()
        {
            return this.$language;
        },
    },
};


export default component;


// WEBPACK FOOTER //
// ./src/modules/restaurants/Views/Component.js